/**
 * Registers amazon-ecs plugin APIs in the frontend system.
 *
 * DEFERRED — cannot migrate to native without upstream changes.
 * Status: BLOCKED (upstream) — app-side compat only.
 *
 * Blocker: `@aws/amazon-ecs-plugin-for-backstage` does not export
 * `amazonEcsApiRef` or `AmazonEcsApiClient` from its public type surface.
 * Both are internal to the plugin's legacy `createPlugin` wiring.
 * Without these exports a native `ApiBlueprint` factory cannot be written.
 *
 * `EntityAmazonEcsServicesContent` depends on `amazonEcsApiRef`
 * (`plugin.amazon-ecs.service`) at runtime; without this module the ECS tab
 * throws NotImplementedError.
 *
 * Migration path: Wait for upstream to export the apiRef + client class
 * publicly, then apply the same pattern used for `githubPullRequestsModule`.
 * Upstream: https://github.com/awslabs/backstage-plugins-for-aws
 */
import { convertLegacyPlugin } from '@backstage/core-compat-api';
import { amazonEcsPlugin } from '@aws/amazon-ecs-plugin-for-backstage';

export default convertLegacyPlugin(amazonEcsPlugin, { extensions: [] });
